import {
  utils,
} from '@ama-sdk/core';
import {
  RegulatoryDetail,
  RegulatoryDetailsCategoryRequirement,
  RegulatoryDetailsReplyData,
} from '@dapi/sdk';
import {
  combineRegulatoryDetails,
  combineRegulatoryDetailsCategoryRequirements,
  combineRegulatoryDetailsRequirements,
  createRegulatoryDetailsReplyData,
  RegulatoryDetailRepository,
  RegulatoryDetailsCategoryRequirementRepository,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  travelers,
} from './journey-logic';

let missingDetails: RegulatoryDetailsCategoryRequirement[] = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        canBeDeclined: false,
        requiredDetailsFields: ['birthPlace', 'nationalityCountryCode', 'countryOfResidence']
      }
    ]).items
  },
  RegulatoryDetailsCategoryRequirementRepository.MISSING_TSA
]).items;

let storedDetails: RegulatoryDetail[] = [RegulatoryDetailRepository.STORED_TSA];

export const regulatories: RegulatoryDetailsReplyData[] = [];

/**
 *
 */
function addRegulatory() {
  regulatories.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatories.at(-1),
        storedDetails,
        missingDetails
      }
    })
  );
}

addRegulatory();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'FRA'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['birthPlace', 'countryOfResidence']
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'FRA',
    countryOfResidence: 'FRA',
    countryOfResidenceCode: 'FRA'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['birthPlace']
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      detailsType: 'document',
      regulatoryType: 'passport'
    }, {
      detailsType: 'document',
      regulatoryType: 'identityCard'
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: 'A1234567'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'countryEntryDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      detailsType: 'document',
      regulatoryType: 'visa',
      requiredDetailsFields: ['cityName'],
      canBeDeclined: false
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: 'A1234567'
    }
  },
  {
    document: {
      documentType: 'visa',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'FR',
      issuanceLocation: 'Tours',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: '12345678'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'destinationAddress',
    detailsChoices: [{
      canBeDeclined: false,
      detailsType: 'address',
      regulatoryType: 'destinationAddress',
      requiredDetailsFields: ['lines', 'zipCode', 'cityName']
    }]
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: 'A1234567'
    }
  },
  {
    document: {
      documentType: 'visa',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'FR',
      issuanceLocation: 'Tours',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: '12345678'
    }
  },
  {
    address: {
      cityName: 'Nice',
      lines: ['abcd'],
      zipCode: '06700',
      countryCode: 'FR',
      type: 'destinationAddress'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'homeAddress',
    detailsChoices: [{
      canBeDeclined: false,
      detailsType: 'address',
      regulatoryType: 'destinationAddress',
      requiredDetailsFields: ['lines', 'zipCode', 'cityName']
    }]
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: 'A1234567'
    }
  },
  {
    document: {
      documentType: 'visa',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'FR',
      issuanceLocation: 'Tours',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: '12345678'
    }
  },
  {
    address: {
      cityName: 'Nice',
      lines: ['abcd'],
      zipCode: '06700',
      countryCode: 'FR',
      type: 'destinationAddress'
    }
  },
  {
    address: {
      cityName: 'Nice',
      lines: ['abcd'],
      zipCode: '06700',
      countryCode: 'FR',
      type: 'homeAddress'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: [{
      canBeDeclined: false,
      detailsType: 'phone',
      regulatoryType: 'emergencyContact',
      requiredDetailsFields: ['number', 'countryOfResidence', 'countryPhoneExtension']
    }]
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidence: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthPlace: 'Tours'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: 'A1234567'
    }
  },
  {
    document: {
      documentType: 'visa',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'FR',
      issuanceLocation: 'Tours',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: '12345678'
    }
  },
  {
    address: {
      cityName: 'Nice',
      lines: ['abcd'],
      zipCode: '06700',
      countryCode: 'FR',
      type: 'destinationAddress'
    }
  },
  {
    address: {
      cityName: 'Nice',
      lines: ['abcd'],
      zipCode: '06700',
      countryCode: 'FR',
      type: 'homeAddress'
    }
  },
  {
    phoneNumber: {
      purpose: 'emergencyContact',
      countryCode: 'FR',
      countryPhoneExtension: 'FR',
      name: {
        lastName: 'salamito'
      },
      number: '1234567890'
    }
  }
]).items;

missingDetails = [];

addRegulatory();

export const [getRegulatoryDetails, ...addRegulatoryDetails] = regulatories;
